import React from "react";
import { Link, useLocation } from "react-router-dom";
import PageWrapper from "../components/PageWrapper";

export default function NotFound() {
  const { pathname } = useLocation();

  const Content = (
    <main className="py-16">
      <div className="container-x grid md:grid-cols-2 gap-8 items-center">
        {/* Left: message */}
        <div>
          <p className="uppercase tracking-[0.2em] text-[#D4FF00] font-extrabold text-xs">404</p>
          <h1 className="text-4xl md:text-5xl font-extrabold mt-2">
            Lost in the dungeon?
          </h1>
          <p className="text-neutral-400 mt-3 max-w-[48ch]">
            We couldn’t find <span className="text-neutral-200">{pathname}</span>.
            Maybe the boss moved it—or the link was a bit sus. Let’s get you back to the lobby.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/"
              className="btn hover:bg-black hover:text-white transition-colors"
            >
              Back to Home
            </Link>
            <Link
              to="/booking"
              className="btn btn-accent border hover:bg-black hover:text-white transition-colors duration-150 ease-in"
            >
              Book a Session
            </Link>
          </div>

          <p className="text-xs text-neutral-500 mt-4">
            Tip: use the nav to jump straight to Features, FAQ, or Contact.
          </p>
        </div>

        {/* Right: themed card */}
        <div className="card relative overflow-hidden">
          {/* subtle “CRT / scanline” and glow */}
          <div className="absolute inset-0 pointer-events-none mix-blend-soft-light"
               style={{ backgroundImage: "repeating-linear-gradient(0deg, rgba(255,255,255,.04), rgba(255,255,255,.04) 1px, transparent 1px, transparent 3px)" }} />
          <div className="p-6">
            <div className="inline-flex items-center gap-2 text-xs text-neutral-400 mb-3">
              <span className="inline-block w-2 h-2 rounded-full bg-[#D4FF00]/80" />
              <span>Respawn point</span>
            </div>

            <div className="rounded-2xl border border-[#1a1a1a] bg-[#0b0b0b] p-6 shadow-[0_10px_30px_rgba(212,255,0,.08),0_2px_8px_rgba(0,0,0,.6)]">
              <div className="text-6xl font-black tracking-wider text-transparent bg-clip-text bg-gradient-to-br from-[#D4FF00] to-white">
                <Link to="/"><img src="/images/logotest.png" alt="Gaming Cafe" className="w-[220px] md:w-[400px]" /></Link>
              </div>
              <p className="mt-3 text-neutral-300">
                “It’s dangerous to go alone! Take these links.”
              </p>

              <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
                <li>
                  <Link to="/#features" className="block px-3 py-2 rounded-lg hover:bg-white/5 hover:text-[#D4FF00] transition-colors">
                    Features
                  </Link>
                </li>
                <li>
                  <Link to="/pricing" className="block px-3 py-2 rounded-lg hover:bg-white/5 hover:text-[#D4FF00] transition-colors">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link to="/contact#contact-form" className="block px-3 py-2 rounded-lg hover:bg-white/5 hover:text-[#D4FF00] transition-colors">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/#faq" className="block px-3 py-2 rounded-lg hover:bg-white/5 hover:text-[#D4FF00] transition-colors">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* soft vignette */}
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(800px_300px_at_60%_10%,rgba(212,255,0,.06),transparent_55%)]" />
        </div>
      </div>
    </main>
  );

  // If using PageWrapper for transitions, wrap it; otherwise just return Content
  return <PageWrapper>{Content}</PageWrapper>;
}
